<template>
    <div class="row">
        <div class="text-center mt-3 mb-3">
            <img style="height: 280px;" src="../assets/img/img404.webp" alt="" />
            <p class="h1 mt-3 s-color-puro" style="font-weight: 500;">Hmmm!</p>
            <p class="h5 s-color-dos delgado">No encontramos lo que buscabas.</p>
           <br>
            <router-link to="/" class="links2 gordo"><i class="bi bi-chevron-left me-1"></i> Regresar a casa</router-link>
        </div>
        
    </div>
</template>
<script>
export default {

}
</script>